import http from '@/utils/http'

export function login(data){
  return  http.post('/sessions',data)
}
export function switchStudentLogin(data){
  return  http.post('/switchStudentLogin',data)
}
export function logout(params){
  return  http.delete('/sessions',{params})
}
// 修正：接收 options 參數，展開到配置中；參數名對應後端 refresh_token
export function refresh(data, options = {}){
  return  http('/access_token',{
    params: {
      refresh_token: data.refreshToken
    },
    ...options
  })
}
export function forgetPasswordEmail(params){
  return  http('/forget_password_email',{params})
}
export function sendPasswordEmailCode(params){
  return  http('/sendPasswordEmailCode',{params})
}
export function register(data){
    return  http.post('/register',data)
}
export function register2(data){
  return  http.post('/register2',data)
}
export function recaptcha(data){
  return  http.post('/recaptcha',data)
}